import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import { HeaderArea } from './style'
import { useTranslation } from 'react-i18next';
import NotificationCenter from '../../NotificationCenter';

import { doLogout, isLogged, getUserData } from '../../../helpers/AuthHandler';

const Component = () => {
  const logged = isLogged();
  const userData = getUserData();
  const { t, i18n } = useTranslation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    doLogout();
    window.location.href = '/';
    return;
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <HeaderArea>
      <div className="container">
        <div className="logo">
          <Link to="/" onClick={closeMobileMenu}>
            <img
              src="/logo.webp"
              alt="Terserah"
              style={{ height: 40 }}
              onError={e => { e.target.onerror = null; e.target.src = "/logo.png"; }}
            />
            <span className="logo-2">Terserah</span>
            <span className="logo-3">{t('logotipe')}</span>
          </Link>
        </div>
        
        <button className="hamburger" onClick={toggleMobileMenu} aria-label="Toggle menu">
          <span className={mobileMenuOpen ? 'open' : ''}></span>
          <span className={mobileMenuOpen ? 'open' : ''}></span>
          <span className={mobileMenuOpen ? 'open' : ''}></span>
        </button>

        <nav className={mobileMenuOpen ? 'mobile-open' : ''}>
          <ul>
            {logged
              ?
              <>
                <li style={{ position: 'relative' }}>
                  <NotificationCenter />
                </li>
                <li><Link to="/my-account" onClick={closeMobileMenu}><i className="fas fa-user"></i> {userData?.name || t('myAccount')}</Link></li>
                <li><button onClick={() => { handleLogout(); closeMobileMenu(); }}><i className="fas fa-sign-out-alt"></i> {t('logout')}</button></li>
              </>
              :
              <>
                <li><Link to="/signin" onClick={closeMobileMenu}><i className="fas fa-sign-in-alt"></i> {t('login')}</Link></li>
                <li><Link to="/signup" onClick={closeMobileMenu}><i className="fas fa-user-plus"></i> {t('sign_up')}</Link></li>
              </>
            }
            <li><Link to="/post-an-add" className="button" onClick={closeMobileMenu}><i className="fas fa-plus-circle"></i> {t('postAd')}</Link></li>
          </ul>
        </nav>
        <div className="language-selector">
          <button 
            onClick={() => i18n.changeLanguage('en')} 
            className={i18n.language === 'en' ? 'active' : ''}
            aria-label="Change language to English"
          >
            EN
          </button>
          <button 
            onClick={() => i18n.changeLanguage('id')} 
            className={i18n.language === 'id' ? 'active' : ''}
            aria-label="Ganti bahasa ke Indonesia"
          >
            ID
          </button>
          <button 
            onClick={() => i18n.changeLanguage('es')} 
            className={i18n.language === 'es' ? 'active' : ''}
            aria-label="Cambiar idioma a Español"
          >
            ES
          </button>
        </div>
      </div>
    </HeaderArea>
  );
};

export default Component;